import {Injectable} from '@angular/core';
import {GeolokationDTO, ProductionSiteDTO, SocialsDTO, TenantsDetailsDTO} from '@rsp/models/dto/tenants-details.dto';
import {Observable, of} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {TenantDTO} from '@rsp/models/dto/tenant.dto';
import {RspEndpointsService} from '@rsp/shared/services/rest/rsp-endpoints.service';

@Injectable()
export class TenantConfigService {

  private tenantName: string;
  private tenant: TenantDTO;
  private tenantDetails: TenantsDetailsDTO;
  private detailsObservable: Observable<TenantsDetailsDTO>;

  constructor(private rspEndpointsService: RspEndpointsService) {
  }

  public init(): Promise<boolean> {
    this.tenantName = this.stripTenantFromDomain(location.host);
    return this.setTenantInfos(this.tenantName);
  }

  public getId(): string {
    return this.tenantName;
  }

  public getInfo(): TenantDTO {
    return this.tenant;
  }

  public getGeolocations(): Promise<GeolokationDTO[]> {
    return new Promise<GeolokationDTO[]>((resolve) => {
      this.getDetails().then((dto) => {
        resolve(dto.geoLocations);
      }).catch(() => {
        resolve([]);
      });
    });
  }


  public getSocials(): Promise<SocialsDTO[]> {
    return new Promise<SocialsDTO[]>((resolve) => {
      this.getDetails().then((dto) => {
        resolve(dto.socials);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public getProductionSites(): Promise<ProductionSiteDTO[]> {
    return new Promise<ProductionSiteDTO[]>((resolve) => {
      this.getDetails().then((dto) => {
        resolve(dto.productionSites);
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public stripTenantFromDomain(url: string): string {
    // get subdomain and search for tenant in subdomains array
    const sub = url.split('.');
    return !!sub[0] ? sub[0].toUpperCase() : undefined;
  }

  private getDetails(): Promise<TenantsDetailsDTO> {
    if (this.tenantDetails) {
      return of(this.tenantDetails).toPromise();
    } else if (this.detailsObservable) {
      return this.detailsObservable.toPromise();
    } else {
      this.detailsObservable = this.rspEndpointsService.getTenantDetails(this.tenantName).pipe(
        map(response => {
          this.detailsObservable = null;
          this.tenantDetails = response.result;

          return this.tenantDetails;
        }),
        shareReplay({bufferSize: 1, refCount: true}));

      return this.detailsObservable.toPromise();

    }
  }

  private setTenantInfos(tenantName: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.rspEndpointsService.getTenant(tenantName).subscribe((dto) => {
        if (dto.result !== undefined) {
          this.tenant = dto.result;
          resolve(true);
        } else {
          // TODO: RSP-???, Wie gehen wir mit BE down um
          reject('Missing tenant information!');
        }
      }, (err) => {

      });
    });
  }
}
